import React from 'react'

const Watermark = props => {
    return (
        <>
            {(props.count || []).map(k => (
                <svg className="watermark" style={{ top: k * 1300 + ((k > 0 ? 600 : 300)) }} key={`watermark-${k}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 443.59 443.59">
                    <g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><text className="cls-1" transform="translate(43.48 421.49) rotate(-45)">CONFIDENTIAL</text></g></g>
                </svg>
            ))}
        </>
    )
}

export default Watermark